/**
 * Calender content module
 *
 * @module Calendar
 * @author EN GARDE (Reinhold Seiss)
 * @version 1.0
 */

var EN = EN || {};

EN.Sticky = (function ($) {
	'use strict';

	var options = {
		selectors: {
			backToTopButton: '.en-back-to-top',
			stickyHeader: '#en_sticky_header',
		}
	};

	/**
	 * Initializes Calendar component and sets listeners for animations.
	 * @memberof module:Calendar
	 */
	var init = function () {
		// $(options.selectors.backToTopButton).stickybits({
		// 	useStickyClasses: true,
		// 	stickyBitStickyOffset: 154,
		// 	verticalPosition: 'bottom',
		// });
		$(options.selectors.stickyHeader).sticky({
			// useStickyClasses: true,
			// stickyBitStickyOffset: 66
			topSpacing: 83,
			className: 'js-is-sticky',
			wrapperClassName: 'en-sticky-wrapper'
		});


		$(options.selectors.stickyHeader).sticky({
			// useStickyClasses: true,
			// stickyBitStickyOffset: 66
			topSpacing: 83,
			className: 'js-is-sticky',
			wrapperClassName: 'en-sticky-wrapper'
		});

	};

	// exports
	return {
		init: init
	};
}(jQuery));


